module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/aoj_a-1-0f842eb39e154651fdf49a44d4f498cd.jpg";